// extracted by mini-css-extract-plugin
export var label = "_91-1";
export var reminder = "_91-0";